/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var ko = require("knockout");

var pliObservable = require("../forms-knockoutcontrols");
var stringUtil = require("../util/string");

var shared = require("./shared");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// StringAdvancedSearchItem template
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

/**
 * Advanced search item for doing basic string comparisons.
 */
function StringAdvancedSearchItem(behaviourData) {
    if (!(this instanceof StringAdvancedSearchItem)) { return new StringAdvancedSearchItem(behaviourData); } // if new was not used, force it now

    // indicates how the string fields are searched
    // - `contains` includes any items with partial matches (default)
    // - `not contain` excludes any items with partial matches
    // - `is` include any items with exact matches
    // - `is not` excludes any items with exact matches
    // - `is empty` includes items that do not have a value (`enableEmpty` must be set on behaviourData)
    // - `is not empty` includes items that have any value (`enableEmpty` must be set on behaviourData)
    this.operator = ko.observable("contains");

    // contains value of the phrase to match
    this.value = pliObservable();

    // extras
    this.extras = function stringAdvancedSearchItemExtras() { return; };
    this.extras.enableEmpty = !!(behaviourData && behaviourData.enableEmpty);
    this.extras.isEmpty = ko.pureComputed(shared.containsEmpty, this.operator);
}


/**
 * Gets the id used by the browser to uniquely identify the dom element.
 * @type {String}
 */
StringAdvancedSearchItem.prototype.templateId = "stringAdvancedSearchItem";


/**
 * Loads the value of this view-model from the advancedSearch item.
 * @param {string} phrase
 *      The search phrase.
 * @param {boolean} not
 *      Whether to invert the search.
 */
StringAdvancedSearchItem.prototype.load = function stringAdvancedSearchItemLoad(phrase, not) {
    var textValue, operatorValue = "contains"; // default is "contains"
    if (not) {
        phrase = phrase.trim();
        textValue = phrase.replace(shared.removeSurroundingWildcards, "");
        operatorValue = phrase === "[empty]"
            ? "is not empty"
            : (phrase[0] === "*" && phrase[phrase.length - 1] === "*") ? "not contain" : "not";

    } else if (stringUtil.isNullOrWhitespace(phrase)) {
        textValue = "";
    } else {
        phrase = phrase.trim();
        textValue = phrase.replace(shared.removeSurroundingWildcards, "");
        if (phrase === "[empty]") {
            operatorValue = "is empty";
        } else if (textValue[0] === phrase[0] || textValue[textValue.length - 1] === phrase[phrase.length - 1]) {
            // if "*" were not removed at the start and end of the string, then operator is "is" for string queries
            operatorValue = "is";
            textValue = phrase;
        }
    }

    this.operator(operatorValue);
    this.value.load(textValue);
};


/**
 * Saves the value of this view-model to the advancedSearch item.
 * @return {any[]}
 *      An array tuple containing [phrase, not] - the phrase and whether the search should be inverted.
 */
StringAdvancedSearchItem.prototype.save = function stringAdvancedSearchItemSave() {
    var phrase, not,
        operator = this.operator(),
        value = this.value();
    value = stringUtil.isNullOrWhitespace(value) ? "" : value;

    switch (operator) {
    case "not":
        phrase = value;
        not = true;
        break;
    case "is":
        phrase = value;
        not = false;
        break;
    case "is empty":
        phrase = "[empty]";
        not = false;
        break;
    case "is not empty":
        phrase = "[empty]";
        not = true;
        break;
    case "not contain":
        phrase = (value === ""
            ? value
            : "*".concat(value.replace(shared.removeSurroundingWildcards, ""), "*"));
        not = true;
        break;
    default:
        phrase = (value === ""
            ? value
            : "*".concat(value.replace(shared.removeSurroundingWildcards, ""), "*"));
        not = false;
        break;
    }

    return [phrase, not];
};

module.exports = StringAdvancedSearchItem;




//////////////////
// WEBPACK FOOTER
// ./~/pli/advancedsearch/stringAdvancedSearchItem.js
// module id = 453
// module chunks = 49